
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import httpClient from "@/store/httpClient";
const Chart = require("chart.js");

@Component
export default class ComplainRateReport extends Vue {
	private chart: any = null;
	private data: any = [];
	private loading: boolean = false;
	private mounted() {
		this.loadReport();
	}

	private async loadReport() {
		try {
			this.loading = true;
			const response = await httpClient().get(`System/GetCamProcessUsageData`);
			this.data = response.data;
			this.updateDiagram();
		} catch (err) {
			console.error("Loading usage data failed.");
			console.error(err);
			this.$store.commit(
				"setSnackbarErrorText",
				"Fehler beim Laden der Daten. Siehe Konsole."
			);
		} finally {
			this.loading = false;
		}
	}

	private getDatasets() {
		const sets = [];
		sets.push(this.data.map((d: any) => d.timestamp));
		sets.push(this.data.map((d: any) => d.numberOfRunningProcesses));
		sets.push(this.data.map((d: any) => d.numberOfProcessesInUse));
		sets.push(this.data.map((d: any) => d.numberOfExecutingProcesses));
		sets.push(this.data.map((d: any) => d.numberOfPendingCommands));

		console.log(sets[0]);
		return [
			{
				label: "Gestartete Prozesse",
				data: sets[1],
				borderColor: "rgba(0, 204, 102, 0.1)",
				backgroundColor: "rgba(0, 204, 102, 0.1)",
			},
			{
				label: "Aktuell zugeteilte Prozesse",
				data: sets[2],
				borderColor: "rgba(255, 0, , 0.1)",
				fill: false,
			},
			{
				label: "Anzahl Prozesse die aktuell arbeiten",
				data: sets[3],
				borderColor: "rgba(235, 187, 32, 1)",
				fill: false,
			},
			{
				label: "Wartende Berechnungen",
				data: sets[4],
				borderColor: "rgba(30, 60, 240, 1)",
				fill: false,
			},
		];
	}

	private updateDiagram() {
		// Destroy the chart if one already exists.
		if (this.chart != null) {
			this.chart.destroy();
		}

		const ctx = (this.$refs.diagramCanvas as any).getContext("2d");
		this.chart = new Chart(ctx, {
			type: "line",
			data: {
				labels: this.data.map((d: any) => d.timestamp),
				datasets: this.getDatasets(),
			},
			options: {
				elements: {
					line: {
						tension: 0, // disables bezier curves
					},
				},
				animation: {
					duration: 0, // general animation time
				},
				hover: {
					animationDuration: 0, // duration of animations when hovering an item
				},
				responsiveAnimationDuration: 0, // animation duration after a resize
			},
		});
		this.chart.update();
	}
}
